import { useInfiniteQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getAdminSettlements } from 'services/fund/settlement'

export default function useGetAdminSettlements() {
    const { moneyPool } = useParams()
    const { data, isLoading, fetchNextPage, refetch } = useInfiniteQuery(
        ['settlements-listss'],
        ({ pageParam = 1, queryKey }) =>
            getAdminSettlements(pageParam, moneyPool),
        {
            getNextPageParam: (lastPage, allPages) => {
                const lastRecord = allPages[allPages.length - 1]?.next || ''
                return lastRecord
                    ? new URL(lastRecord).searchParams.get('page')
                    : undefined
            },
        }
    )
    return {
        settlements: data,
        isLoadingSettlements: isLoading,
        fetchNextPage,
        refetch,
    }
}
